import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.tax_category.suppored')
    },
    {
      id: 2,
      name: i18n.t('tipos.tax_category.repercussed')
    },
  ]
}

export function TIPOS_CATEGORIA_IMPUESTOS (state) {
  return configHelper.getConfig(state, 'TIPOS_CATEGORIA_IMPUESTOS', GenerateConfig)
}
